<template>
<section class="container">
  <template v-if="showPage">
  <!-- 进场开闸成功的情况 -->
  <template v-if="!showKaizhaStatus">
      <div class="con_title" v-if="parkDate.msg">
        <img v-if="parkDate.code == 0" class="con_title_icon" src="../../assets/images/evaluate/success.png">
        <img v-else class="con_title_icon" src="../../assets/images/evaluate/icon_warning_secondary.png">
        <p class="con_title_t">{{parkDate.msg}}</p>
      </div>
      <template v-if="!hasCardNumber">
        <p class="con_time_title" v-if="entranceType==1">本次自助进出随机码为</p>
        <p class="con_time_title con_time_titlet" v-if="entranceType==2 && parkDate.parkingFee">自动进出随机码</p>
        <random-code :randomCode="entranceType==2?parkDate.selfOutRandomCode:parkDate.selfInRandomCode"></random-code>
      </template>
      <div class="topBox" v-else>
        <img class="topBox_bg" src="../../assets/images/parkService/parkingSearchSuccess.jpg">
        <div class="carkNumber">{{parkDate.carCode}}</div>
      </div>
      <div class="infoBox">
        <div class="info_line" v-if="parkDate.parkName">
          <div class="info_left">停车场名称</div>
          <div class="info_right">{{parkDate.parkName}}</div>
        </div>
        <div class="info_line">
          <div class="info_left">入场时间</div>
          <div class="info_right">{{parkDate.enterDate|filtersDate}}</div>
        </div>
        <div class="info_line" v-if="parkDate.parkingTime">
          <div class="info_left">停车时长</div>
          <div class="info_right">{{parkDate.parkingTime|filterParkingTime}}</div>
        </div>
        <div class="info_line" v-if="parkDate.parkingFee">
          <div class="info_left">停车费</div>
          <div class="info_right">¥{{parkDate.parkingFee|priceFormat}}</div>
        </div>
        <div class="info_line info_line2" v-if="parkDate.paidValue || parkDate.paidValue === 0">
          <div class="info_left">已支付</div>
          <div class="info_right">¥{{parkDate.paidValue|priceFormat}}</div>
        </div>
        <div class="info_bottom" v-if="parkDate.shouldPayValue">
          <div class="info_bottom_left">需支付</div>
          <div class="info_bottom_right">¥{{parkDate.shouldPayValue|priceFormat}}</div>
        </div>
      </div>
    </template>
    <!-- 出场开闸成功,开闸失败的情况 -->
    <section class="kaizha_status" v-else>
      <div class="con_title">
        <img v-if="kaizhaStatus==1" class="con_title_icon" src="../../assets/images/evaluate/success.png">
        <img v-else class="con_title_icon" src="../../assets/images/evaluate/icon_warning_secondary.png">
        <p class="con_title_t">{{kaizhaStatus==1?'开闸成功':'开闸失败'}}</p>
      </div>
      <p class="con_time_title" v-if="kaizhaStatusText">{{kaizhaStatusText}}</p>
      <p class="con_time_title" v-if="kaizhaStatus==1">欢迎再次光临~</p>
    </section>
    <!-- 查看在场记录 -->
    <!-- <section class="footer_btn">
      <p>查看在场记录</p>
    </section> -->
    <section class="footer_height"></section>
    <div class="bottomBtn_wrap button" v-if="entranceType==2 && !parkDate.msg && parkDate.shouldPayValue">
      <div :class="['btn' ,'bottomBtn' ,'btn_default',canPay?'':'btn_Hui']" @click="createOrderNo">
        立即支付
      </div>
    </div>
  </template>
</section>
</template>

<script>
import {mapState} from 'vuex';
import {freeCall} from '../../utils/api'
import ping from '../../utils/pingpay.js'
import RandomCode from './components/randomCode'
import util from '../../utils/util'
export default {
  name: 'parkingScanDetail',
  props: {},
  components: {
    RandomCode
  },
  filters: {
    filtersDate(value) {
      return value ? value.slice(0, 4) + '-' + value.slice(4, 6) + '-' + value.slice(6, 8) + ' ' + value.slice(8, 10) + ':' + value.slice(10, 12) + ':' + value.slice(12, 14) : '';
    },
    filterParkingTime(value) {
      return util.selvateTime(value) ? util.selvateTime(value) : '0分钟'
    },
    filterCarCode(value) {
      return value ? value.slice(0, 2) + '·' + value.slice(2) : '';
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      showKaizhaStatus:false,//是否展示开闸成功失败
      kaizhaStatus:1,//1开闸成功,2开闸失败
      kaizhaStatusText:'',
      entranceType:'',//1进场,2离场
      parkDate:{},
      orderInfo:{},
      canPay:true,
      showPage:false,
      hasCardNumber:false
    }
  },
  created(){
    this.entranceType = this.$route.params.entranceType || '';
    this.parkingSearch()
  },
  methods:{
    // 自助码查询
    parkingSearch(){
      util.showLoading()
      let params = {
        parkCode:this.$route.params.parkCode,//车场编号
        channelSeq:this.$route.params.channelSeq,//随机码
        userUniqCode:this.common.openId,
        url:'/parking/rstParkBill/scanChannel'
      }
      // 判断是否从手动输入自助码进来
      if(this.$route.query.come == 'parkingSearch'){
        params = {
          parkCode:this.$route.params.parkCode,//车场编号
          randomCode:this.$route.params.channelSeq,//随机码
          userUniqCode:this.common.openId,
          url:'/parking/rstParkBill/randomChannel'
        }
      }
      freeCall(params).then(res=>{
        console.log(res)
        util.hideLoading()
        this.showPage = true;
        if(res.res && res.res.code === 10000 && res.body){
          this.parkDate = res.body.data;
          // 判断是否有车牌
          if(this.parkDate.carCode && this.parkDate.carCode.length <= 8){
            this.hasCardNumber = true;
          }else{
            this.hasCardNumber = false;
          }
          // 开闸成功
          if(this.parkDate.msg && this.parkDate.code === 0 && this.entranceType == 2){
            this.kaizhaStatus = 1
            this.showKaizhaStatus = true
          }
        }else{
          this.kaizhaStatus = 2 //开闸失败
          this.kaizhaStatusText = res.res.msg
          this.showKaizhaStatus = true
        }
      })
    },
    createOrderNo() {
      if(!this.parkDate.shouldPayValue || !this.canPay){
        return
      }
      this.canPay = false;
      let value = this.parkDate.enterDate || '';
      let inTime = value ? value.slice(0, 4) + '.' + value.slice(4, 6) + '.' + value.slice(6, 8) + ' ' + value.slice(8, 10) + ':' + value.slice(10, 12) + ':' + value.slice(12, 14) : '';
      let postInfo = {
        "parkHeaderId": parseInt(this.parkDate.parkHeaderId),
        "subProjectId": this.common.marketInfo.id,
        'amount': this.parkDate.shouldPayValue,
        "plateNo": this.parkDate.selfOutRandomCode || this.parkDate.selfInRandomCode,
        "parkingCode": this.parkDate.parkingCode || '',
        "openId": this.common.openId,
        "userId": this.common.userId || '',
        "userName": this.common.userId ? this.common.userTenantInfo.userName?this.common.userTenantInfo.userName:this.common.userInfo.userName : '',
        "phone": this.common.userId ? this.common.userInfo.phone || this.common.userInfo.account : '',
        "parkingFee":this.parkDate.parkingFee,
        "chargeDate":this.parkDate.chargeDate,
        'freeAmount': 0,
        "inTime": inTime,
        "payAmount":this.parkDate.shouldPayValue,
        'url': '/parking/rstParkBill/parkTemporaryBill'
      }
      if(this.hasCardNumber){
        postInfo.plateNo = this.parkDate.carCode
      }
      util.showLoading();
      freeCall(postInfo).then(res => {
        console.log(res)
        util.hideLoading();
        if (res.res.code == 10000) {
          if(res.body.msg == "success"){
            this.orderInfo = res.body.data
            this.pingPay()
          }else{
            this.canPay = true
            util.showToast(res.body.msg);
          }
        }else{
          this.canPay = true
        }
      });
    },
    pingPay() {
      let self = this;
      let params = {
        orderNo: this.orderInfo.orderNo,
        repairNo: '', // "报修单号",
        bussinessType: "7", //临时停车
        feeCode:this.parkDate.parkHeaderId,
        channel: 'wx_pub' // 渠道名
      };
      ping(params,'',
        () => {
          self.paySuccess();
        }, () => {
          self.canPay = true;
          util.showToast("支付失败");
        }, () => {
          self.canPay = true;
          util.showToast("支付取消");
        })
    },
    paySuccess() {
      this.$router.replace(`/paySuccess?outEffectiveTime=${this.parkDate.outEffectiveTime}&plateNo=${this.parkDate.selfOutRandomCode}&come=random`);
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.con_title {
    margin-top: 80px;
    display: flex;
    align-items: center;
    flex-direction:column;
    .con_title_icon {
      width:116px;
      height:116px;
      margin-bottom:28px;
    }
    .con_title_t {
      font-size: 44px;
      color: rgba(51,51,51,1);
      line-height: 60px;
      margin-bottom:20px;
    }
}
.con_time_title{
  height:42px;
  font-size:30px;
  color:rgba(102,102,102,1);
  line-height:42px;
  margin-bottom:40px;
  text-align:center;
}
.con_time_titlet{
  margin-top:60px;
}
.infoBox {
      padding:20px 40px;
      margin:80px 20px 120px;
      background: rgba(255,255,255,1);
      box-shadow: 0 12px 50px 0 rgba(0,0,0,0.08);
      border-radius: 8px;
      .info_line {
          display: flex;
          flex-direction: row;
          padding: 20px 0;
          align-items: center;
          justify-content: space-between;
          .info_left {
              font-size: 30px;
              line-height: 42px;
              color: rgba(102,102,102,1);
          }
          .info_right {
              flex: 1;
              color: rgba(51,51,51,1);
              font-size: 30px;
              line-height: 42px;
              text-align: right;
          }
      }
      .info_line2 {
          margin-bottom: 20px;
      }
      .info_bottom {
          height: 110px;
          border-top: 1px solid #EAEAEA;
          display: flex;
          align-items: center;
          .info_bottom_left {
              font-size: 36px;
              color: #333;
          }
          .info_bottom_right {
              flex: 1;
              color: #FD001B;
              font-size: 36px;
              text-align: right;
          }
      }
    }

// .footer_btn{
//   position: fixed;
//   bottom:0;left:0;right:0;
//   height:108px;
//   line-height: 108px;
//   text-align: center;
//   background:rgba(255,255,255,1);
//   box-shadow:0px -4px 16px 0px rgba(0,0,0,0.06);
//   font-size:32px;
//   color:rgba(23,64,218,1);
//   z-index:2;
// }
// 开闸成功
.con_title {
    margin-top: 80px;
    display: flex;
    align-items: center;
    flex-direction:column;
    .con_title_icon {
      width:116px;
      height:116px;
      margin-bottom:28px;
    }
    .con_title_t {
      font-size: 44px;
      color: rgba(51,51,51,1);
      line-height: 60px;
      margin-bottom:20px;
    }
}
.con_time_title{
  height:42px;
  font-size:30px;
  color:rgba(102,102,102,1);
  line-height:42px;
  margin-bottom:40px;
  text-align:center;
}
.footer_height{
  height:108px;
}
.bottomBtn_wrap {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 108px;
  background: #fff;
  .btn {
      width: 694px;
      height: 76px;
      background: rgba(218,218,218,1);
      border-radius: 4px;
      margin: 16px 28px;
      font-size: 32px;

      text-align: center;
      line-height: 76px;
      color: #fff;
  }
  .bottomBtn {
      background: #1740DA;
      color: #fff;
  }
  .btn_Hui{
    background:rgba(218,218,218,1)!important;
    color: #fff!important;
  }
}
.topBox {
  height: 362px;
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
  .topBox_bg {
      position: absolute;
      top: 40px;
      left: 154px;
      width: 444px;
      height: 202px;
      z-index: 1;
  }
  .carkNumber {
      position: relative;
      z-index: 2;
      height: 66px;
      font-size: 48px;
      color: rgba(51,51,51,1);
      line-height: 66px;
      letter-spacing: 1px;
      margin: 168px 0 28px;
  }
}
</style>
